import { createReducer, on } from "@ngrx/store";
import { WithholdingGroup } from "../../models/withholding-group";
import { loadWithholdingGroupByIdAct, resetWithholdingGroupAct, saveSuccessWithholdingGroupAct, setViolationsWithholdingGroupAct, showMsgErrorAct, updateSuccessWithholdingGroupAct } from "./withholding-group.action";

const withholdingGroup: WithholdingGroup = new WithholdingGroup();

export const withholdingGroupReducer = createReducer (
    {
        withholdingGroup,
        violations: {},
        loading: true
    },
    on(resetWithholdingGroupAct, (state) => ({
        withholdingGroup:  { ...withholdingGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadWithholdingGroupByIdAct, (state, { withholdingGroup }) =>({
        withholdingGroup: { ...withholdingGroup}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessWithholdingGroupAct, (state, { withholdingGroupNew }) => ({
        withholdingGroup: { ...withholdingGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessWithholdingGroupAct, (state, { withholdingGroupUpdated }) => ({
        withholdingGroup: { ...withholdingGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsWithholdingGroupAct, (state, { withholdingGroupForm, violations }) => ({
        withholdingGroup: { ...withholdingGroupForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        withholdingGroup: state.withholdingGroup ,
        violations: {},
        loading: false
    }))
)